import { useTranslation } from "react-i18next";
import { formatDate } from "@/utils/date.utils";
import { UserAvatar } from "@/components/core/UserAvatar";
import { Card, CardContent } from "@/components/ui/card";
import { MemberProfileProps } from "./types";

export function MemberProfile({
  member,
  totalVisits,
  lastVisitDate,
}: MemberProfileProps) {
  const { t } = useTranslation();

  return (
    <Card className="border-none shadow-none px-0">
      <CardContent className="space-y-6 px-0">
        <div className="flex items-start gap-4">
          <UserAvatar
            imageUrl={member.imageUrl}
            name={`${member.firstName} ${member.lastName}`}
            size="xl"
          />

          <div className="space-y-1">
            <h2 className="text-xl font-semibold">
              {member.firstName} {member.lastName}
            </h2>

            <div className="text-xs text-muted-foreground">
              {t("customers.totalVisits", { count: totalVisits })}
            </div>

            {lastVisitDate && (
              <div className="text-xs text-muted-foreground">
                {t("customers.lastVisitDate", {
                  date: formatDate(lastVisitDate),
                })}
              </div>
            )}
          </div>
        </div>
      </CardContent>

    </Card>
  );
}
